/* SALDÚ · Página de producto enfocada en la necesidad (borrador "Copia de Dawn")
   - Ofertas: se leen de la app de pago contraentrega (Releasit), así los precios
     siempre coinciden con el formulario.
   - Entrega: fechas estimadas en días hábiles de Colombia (sin festivos).
   - Tarjetas que se voltean, "ENVÍO GRATIS" que lleva a las ofertas. */
(function () {
  'use strict';
  if (window.__salduLanding) return;
  window.__salduLanding = true;

  /* Festivos de Colombia (lunes festivos incluidos) */
  var FESTIVOS = [
    '2026-11-02', '2026-11-16', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-01-11', '2027-03-22', '2027-03-25', '2027-03-26',
    '2027-05-10', '2027-05-31', '2027-06-07', '2027-07-05', '2027-07-20',
    '2027-08-16', '2027-10-18', '2027-11-01', '2027-11-15', '2027-12-08'
  ];

  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + dos(d.getMonth() + 1) + '-' + dos(d.getDate()); }
  function esHabil(d) { var w = d.getDay(); return w !== 0 && w !== 6 && FESTIVOS.indexOf(ymd(d)) === -1; }
  function sumarHabiles(base, n) {
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    var c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); if (esHabil(d)) c++; }
    return d;
  }
  var fmtFecha;
  try { fmtFecha = new Intl.DateTimeFormat('es-CO', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { fmtFecha = null; }
  function fecha(d) {
    var t = fmtFecha ? fmtFecha.format(d) : d.toLocaleDateString();
    return t.replace(/\./g, '').replace(/,/g, '');
  }
  function plata(centavos) {
    var conDecimales = Math.round(centavos) % 100 !== 0;
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency', currency: 'COP',
        minimumFractionDigits: conDecimales ? 2 : 0,
        maximumFractionDigits: conDecimales ? 2 : 0
      }).format(centavos / 100).replace(/\s/g, '');
    } catch (e) { return '$' + Math.round(centavos / 100); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Formulario de pago contraentrega ---------- */
  /* Abre el formulario y deja marcada la oferta que el cliente tocó.
     oferta = { pos: posición en la app, titulo: título en la app } */
  function abrirFormulario(oferta) {
    var boton = document.querySelector('._rsi-buy-now-button');
    if (!boton) {
      var form = document.querySelector('.product-form__buttons, product-form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    boton.click();
    if (!oferta) return;
    var titulo = String(oferta.titulo || '').trim();
    var intentos = 0;
    function buscar() {
      var opciones = [].slice.call(document.querySelectorAll('._rsi-quantity-offers-offer-container'))
        .filter(function (el) { return el.offsetParent !== null; });
      var meta = opciones.filter(function (el) { return el.getAttribute('data-offer-pos') === String(oferta.pos); })[0];
      if (!meta && titulo) {
        meta = opciones.filter(function (el) {
          var t = el.querySelector('._rsi-quantity-offers-title');
          return t && t.textContent.trim() === titulo;
        })[0];
      }
      return meta;
    }
    var clics = 0;
    (function elegir() {
      var meta = buscar();
      if (!meta) { if (++intentos < 40) setTimeout(elegir, 100); return; }
      /* Ya quedó marcada: no se vuelve a tocar, así el cliente puede cambiarla libremente */
      if (meta.classList.contains('_rsi-quantity-offers-selected') && clics > 0) return;
      if (clics < 3) {
        clics++;
        (meta.querySelector('._rsi-quantity-offers-offer') || meta).click();
        /* La app a veces vuelve a marcar su oferta por defecto al terminar de cargar: se confirma una vez más */
        setTimeout(elegir, 300);
      }
    })();
  }

  /* ---------- Ofertas ---------- */
  function ofertasDe(idProducto) {
    var todas = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (!Array.isArray(todas)) return null;
    var cfg = todas.filter(function (o) {
      return o && o.isActive && Array.isArray(o.pIds) && o.pIds.map(String).indexOf(String(idProducto)) !== -1;
    })[0];
    if (!cfg || !Array.isArray(cfg.offers) || !cfg.offers.length) return null;
    return cfg.offers.slice().sort(function (a, b) { return a.pos - b.pos; });
  }
  function calcular(base, oferta) {
    var bruto = base * oferta.qty;
    var descuento = 0;
    /* Misma fórmula que la app (incluido su redondeo), para que el precio sea idéntico al del formulario */
    if (oferta.ds && oferta.ds.t === 'percentage') descuento = Math.floor(bruto * (oferta.ds.v / 10000));
    else if (oferta.ds && oferta.ds.t === 'fixed') descuento = oferta.ds.v;
    var total = Math.max(bruto - descuento, 0);
    return { bruto: bruto, total: total, ahorro: bruto - total, unidad: total / oferta.qty };
  }
  function regaloPara(idProducto) {
    var lista = window._RSI_COD_FORM_TICK_UPS;
    if (!Array.isArray(lista)) return null;
    var r = lista.filter(function (x) {
      if (!x || !x.isActive || Number(x.price) !== 0) return false;
      if (x.prods === 'all') return true;
      return Array.isArray(x.prods) && JSON.stringify(x.prods).indexOf(String(idProducto)) !== -1;
    })[0];
    return r ? r.title : null;
  }
  function etiquetasDe(mount) {
    var mapa = {};
    try {
      var lista = JSON.parse(mount.getAttribute('data-etiquetas') || 'null') || [];
      lista.forEach(function (s) {
        var p = String(s).split('|');
        var q = parseInt(p[0], 10);
        if (q) mapa[q] = (p.slice(1).join('|') || '').trim();
      });
    } catch (e) {}
    return mapa;
  }

  function pintarOfertas(mount) {
    var idProducto = mount.getAttribute('data-producto');
    var base = Number(mount.getAttribute('data-precio'));
    var ofertas = ofertasDe(idProducto);
    if (!ofertas || !base) return false;

    var etiquetas = etiquetasDe(mount);
    var calc = ofertas.map(function (o) { return { o: o, c: calcular(base, o) }; });
    var multi = calc.filter(function (x) { return x.o.qty > 1; });
    var minUnidad = multi.length ? Math.min.apply(null, multi.map(function (x) { return x.c.unidad; })) : -1;

    var html = calc.slice().sort(function (a, b) { return a.o.qty - b.o.qty; }).map(function (x) {
      var o = x.o, c = x.c, tags = [];
      if (o.qty === 2 && o.ds && o.ds.t === 'percentage' && Number(o.ds.v) === 5000) tags.push('2×1');
      if (o.qty > 1 && c.unidad === minUnidad && multi.length > 1) tags.push('Mejor precio por unidad');
      var nombre = o.qty === 1 ? '1 unidad' : o.qty + ' unidades';
      var ahorro = Math.floor(c.ahorro / 100) * 100;
      return '<button type="button" class="saldu-oferta__card' + (tags.length ? ' is-destacada' : '') + '" data-titulo="' + esc(o.title) + '" data-pos="' + esc(o.pos) + '">' +
        (tags.length ? '<span class="saldu-oferta__tag">' + esc(tags.join(' · ')) + '</span>' : '') +
        '<span class="saldu-oferta__qty" aria-hidden="true">' + o.qty + '</span>' +
        '<span class="saldu-oferta__info"><strong>' + nombre + '</strong>' +
          (etiquetas[o.qty] ? '<span>' + esc(etiquetas[o.qty]) + '</span>' : '') +
          (ahorro > 0 ? '<span class="saldu-oferta__ahorro">Ahorras ' + plata(ahorro) + '</span>' : '') +
        '</span>' +
        '<span class="saldu-oferta__precio">' +
          (c.ahorro > 0 ? '<s>' + plata(c.bruto) + '</s>' : '') +
          '<b>' + plata(c.total) + '</b>' +
          (o.qty > 1 ? '<small>' + plata(Math.round(c.unidad / 100) * 100) + ' c/u</small>' : '') +
        '</span></button>';
    }).join('');

    var lista = mount.querySelector('[data-saldu-lista]');
    if (!lista) return false;
    lista.innerHTML = html;
    [].forEach.call(lista.querySelectorAll('.saldu-oferta__card'), function (card) {
      card.addEventListener('click', function () {
        abrirFormulario({ pos: card.getAttribute('data-pos'), titulo: card.getAttribute('data-titulo') });
      });
    });

    var regalo = regaloPara(idProducto);
    var cajaRegalo = mount.querySelector('[data-saldu-regalo]');
    if (regalo && cajaRegalo) {
      cajaRegalo.innerHTML = '🎁 <strong>Gratis con tu pedido:</strong> ' + esc(regalo.charAt(0) + regalo.slice(1).toLowerCase());
      cajaRegalo.hidden = false;
    }
    mount.hidden = false;
    var bloque = mount.closest('[data-saldu-oferta-bloque]');
    if (bloque) bloque.hidden = false;

    var info = mount.closest('.product__info-container');
    if (info) info.classList.add('saldu-con-ofertas');
    return true;
  }

  /* ---------- Entrega con fechas ---------- */
  function iniciarEntrega(caja) {
    var hoy = new Date();
    var rangos = { principal: [1, 3], resto: [2, 5] };
    var llegada = caja.querySelector('[data-saldu-llegada]');
    var hoyTxt = caja.querySelector('[data-saldu-hoy]');
    if (hoyTxt) hoyTxt.textContent = 'Hoy, ' + fecha(hoy);
    function pintar(zona) {
      var r = rangos[zona] || rangos.principal;
      if (llegada) llegada.textContent = fecha(sumarHabiles(hoy, r[0])) + ' – ' + fecha(sumarHabiles(hoy, r[1]));
      [].forEach.call(caja.querySelectorAll('[data-zona]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-zona') === zona ? 'true' : 'false');
      });
    }
    [].forEach.call(caja.querySelectorAll('[data-zona]'), function (b) {
      b.addEventListener('click', function () { pintar(b.getAttribute('data-zona')); });
    });
    pintar('principal');
  }

  /* ---------- Interacciones ---------- */
  function irAOfertas() {
    var mounts = [].slice.call(document.querySelectorAll('[data-saldu-ofertas]')).filter(function (m) { return !m.hidden; });
    if (!mounts.length) { abrirFormulario(null); return; }
    var destino = mounts[0];
    destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
    destino.classList.remove('is-pulso');
    void destino.offsetWidth;
    destino.classList.add('is-pulso');
  }

  /* ---------- Reseñas (Trustoo) en español ---------- */
  function plural(n, uno, varios) { return n === '1' ? uno : varios; }
  var TRADUCCIONES = [
    [/^Customer Reviews$/i, function () { return 'Lo que dicen nuestros clientes'; }],
    [/^Write a review$/i, function () { return 'Escribir una reseña'; }],
    [/^(\d+)\s*Reviews?$/i, function (m, n) { return n + plural(n, ' reseña', ' reseñas'); }],
    [/^Reviews?$/i, function (m) { return /s$/i.test(m) ? 'reseñas' : 'reseña'; }],
    [/^Stars?$/i, function (m) { return /s$/i.test(m) ? 'estrellas' : 'estrella'; }],
    [/^an? (month|week|day|year|hour|minute) ago$/i, function (m, u) {
      return { month: 'hace 1 mes', week: 'hace 1 semana', day: 'hace 1 día', year: 'hace 1 año', hour: 'hace 1 hora', minute: 'hace 1 minuto' }[u.toLowerCase()];
    }],
    [/^(\d+) (month|week|day|year|hour|minute)s? ago$/i, function (m, n, u) {
      var t = { month: ['mes', 'meses'], week: ['semana', 'semanas'], day: ['día', 'días'], year: ['año', 'años'], hour: ['hora', 'horas'], minute: ['minuto', 'minutos'] }[u.toLowerCase()];
      return 'hace ' + n + ' ' + plural(n, t[0], t[1]);
    }],
    [/^(yesterday)$/i, function () { return 'ayer'; }],
    [/^(today|just now)$/i, function () { return 'hoy'; }],
    [/^(load|show|view) more( reviews)?$/i, function () { return 'Ver más reseñas'; }],
    [/^verified( buyer| purchase)?$/i, function () { return 'Compra verificada'; }],
    [/^most recent$/i, function () { return 'Más recientes'; }],
    [/^highest rating$/i, function () { return 'Mejor calificación'; }],
    [/^lowest rating$/i, function () { return 'Menor calificación'; }],
    [/^with (photos?|pictures?)$/i, function () { return 'Con fotos'; }]
  ];
  function traducirEn(raiz) {
    if (!raiz) return;
    var recorrido = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      var original = nodo.nodeValue;
      var limpio = original.trim();
      if (!limpio) continue;
      for (var i = 0; i < TRADUCCIONES.length; i++) {
        var regla = TRADUCCIONES[i];
        if (regla[0].test(limpio)) {
          var nuevo = limpio.replace(regla[0], regla[1]);
          if (nuevo !== limpio) nodo.nodeValue = original.replace(limpio, nuevo);
          break;
        }
      }
    }
  }
  function traducirResenas() {
    var objetivos = [document.getElementById('trustoo-widget-wrapper')]
      .concat([].slice.call(document.querySelectorAll('.product-icon-list')))
      .filter(Boolean);
    objetivos.forEach(traducirEn);
    return objetivos;
  }
  function vigilarResenas() {
    var pendiente = null;
    var observador = new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; traducirResenas(); }, 60);
    });
    var intentos = 0;
    (function enganchar() {
      var objetivos = traducirResenas();
      var hayWidget = !!document.getElementById('vstar-reviews');
      objetivos.forEach(function (o) {
        if (!o.__salduObservado) { o.__salduObservado = true; observador.observe(o, { childList: true, subtree: true, characterData: true }); }
      });
      if (!hayWidget && ++intentos < 40) setTimeout(enganchar, 250);
    })();
  }

  /* El regalo solo se muestra si está activo en la app de contraentrega */
  function mostrarRegalos() {
    var pendientes = [].slice.call(document.querySelectorAll('[data-saldu-regalo-bloque][hidden], [data-saldu-regalo-mini][hidden]'));
    pendientes.forEach(function (el) {
      if (regaloPara(el.getAttribute('data-producto'))) el.hidden = false;
    });
    return document.querySelectorAll('[data-saldu-regalo-bloque][hidden], [data-saldu-regalo-mini][hidden]').length === 0;
  }
  function irARegalo() {
    var bloque = document.querySelector('[data-saldu-regalo-bloque]:not([hidden])');
    if (bloque) bloque.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else irAOfertas();
  }

  function iniciar() {
    vigilarResenas();
    [].forEach.call(document.querySelectorAll('[data-saldu-entrega]'), iniciarEntrega);
    [].forEach.call(document.querySelectorAll('[data-saldu-ir-regalo]'), function (b) {
      b.addEventListener('click', irARegalo);
    });
    [].forEach.call(document.querySelectorAll('[data-saldu-flip]'), function (card) {
      card.addEventListener('click', function () {
        var v = card.classList.toggle('is-volteada');
        card.setAttribute('aria-pressed', v ? 'true' : 'false');
      });
    });
    [].forEach.call(document.querySelectorAll('[data-saldu-abrir]'), function (b) {
      b.addEventListener('click', function () { abrirFormulario(null); });
    });
    [].forEach.call(document.querySelectorAll('[data-saldu-ir-ofertas]'), function (b) {
      b.addEventListener('click', irAOfertas);
    });

    var mounts = [].slice.call(document.querySelectorAll('[data-saldu-ofertas]'));
    var intentos = 0;
    (function probar() {
      mounts.filter(function (m) { return m.hidden; }).forEach(pintarOfertas);
      var regalosListos = mostrarRegalos();
      var faltan = mounts.some(function (m) { return m.hidden; }) || !regalosListos;
      if (faltan && ++intentos < 25) setTimeout(probar, 200);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
